/**
 * What the phone's refusal means, said to a person (owner, 2026-10-06: a Xiaomi answered every tap with a
 * forty-line `SecurityException` stack, and the hub looked broken while it was fine).
 *
 * **Xiaomi / Redmi / POCO (MIUI, HyperOS)** refuse injected input until "USB debugging (Security
 * settings)" is switched on in Developer options — the picture works, every tap and key fails with
 * `INJECT_EVENTS`. That case gets the fix instead of the stack. Any other Java error is cut to its first
 * sentence: the stack below it is for a developer, and the hub log keeps it whole.
 */

export function explainHint(hint: string, xiaomi: string): string {
  if (!hint) return hint
  if (/INJECT_EVENTS/.test(hint)) return xiaomi
  const cut = hint.split(/\s+at\s+[\w$.]+\(/)[0]!
  return cut.length > 240 ? `${cut.slice(0, 240)}…` : cut
}
